import { TypeAheadFilter } from './TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';
import { QuoteTypeLabels, QuoteType } from '@models/quotes';

export interface QuoteTypeTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

const quoteTypes = {
  [QuoteType.Endorsement]: QuoteTypeLabels[QuoteType.Endorsement],
  [QuoteType.NewBusiness]: QuoteTypeLabels[QuoteType.NewBusiness],
  [QuoteType.Renewal]: QuoteTypeLabels[QuoteType.Renewal],
  [QuoteType.Rewrite]: QuoteTypeLabels[QuoteType.Rewrite],
};

const options = Object.keys(quoteTypes).map((quoteTypeKey) => ({
  key: quoteTypeKey,
  label: QuoteTypeLabels[quoteTypeKey as keyof typeof QuoteTypeLabels],
  value: quoteTypeKey,
}));

export const QuoteTypeTypeaheadFilter = (componentProps: QuoteTypeTypeaheadFilterProps) => {
  const { value, disabled } = componentProps;

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={options}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      horizontalLabel={true}
    />
  );
};
